export default __webpack_public_path__ + "static/media/5w30.d1bef061.png";